import PlansPage from "pages/PlansPage";
import React from "react";

const PlansRoute = () => <PlansPage />;

export default PlansRoute;
